import * as React from "react";
import { AudioVideoProps, AudioVideoDefaultProps, Box, NewsListView, ListView, BPMAlbum, BPMCurated, BPMNews, BPMGenre, UserContextType, WithToast, withToast } from 'bpm-web-generic';
import CoverList from "src/components/views/CoverList";
import GridList from "src/components/views/GridList";
import { RouteComponentProps, withRouter } from "react-router";
import { HorizontalList } from "src/components/views/HorizontalList";
import { NewsAPI, PagingInfo, User, SubscriptionInfo, Session, InvalidSubscriptionError } from "bpm-client-api";
import { apiNewsToBPMNews, apiAlbumToBPMAlbum, mapPlaylistProvider, mapUserPlaylist, mapPlaylist } from "src/transformer";
import Popup from "src/components/views/Popup";
import { Analytics } from "src/manager/AnalyticsManager";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Live } from "./Live";
import { Environment } from "src/env";
import { albumAPI, bannerAPI, mediaAPI, playlistAPI, userPlaylistAPI } from "src/api/config";
import { Banner, SortByQueryOptions } from "src/api/download-api-sdk/src";

const top5Genres = [{
    "id": 51,
    "name": "Hip Hop",
    "slug": "hip-hop",
    "color": "#e94a4a"
},
{
    "id": 68,
    "name": "Pop",
    "slug": "pop",
    "color": "#d83448"
},
{
    "id": 69,
    "name": "Progressive House",
    "slug": "progressive-house",
    "color": "#329ce0"
},
{
    "id": 72,
    "name": "R&B",
    "slug": "r&b",
    "color": "#f73e00"
},
{
    "id": 81,
    "name": "Rock",
    "slug": "rock",
    "color": "#2b355c"
},
{
    "id": 86,
    "name": "Tech House",
    "slug": "tech-house",
    "color": "#6e8899"
},
{
    "id": 91,
    "name": "Trap",
    "slug": "trap",
    "color": "#88bc23"
},
{
    "id": 100,
    "name": "Future House",
    "slug": "future-house",
    "color": "#7a2653"
},
{
    "id": 160,
    "name": "Dance Pop",
    "slug": "dance-pop",
    "color": "#4734d7"
}]

const pagingInfo: PagingInfo = {
    skip: 0,
    limit: 50
}

export interface BPMDropdownItem {
    id: string,
    title: string,
    icon?: string,
    path?: string,
}
interface BrowsePropsMembership { membership: SubscriptionInfo, membershipExpired: boolean }
export interface BrowseProps extends AudioVideoDefaultProps, AudioVideoProps, RouteComponentProps, BrowsePropsMembership, WithToast {
    onLoading: (loading: boolean) => void
}

class BrowseInner extends React.Component<BrowseProps, {
    featured?: BPMAlbum[],
    featured_bpm_orignals?: BPMAlbum[],
    videos?: BPMAlbum[],
    recentlyAdded?: BPMAlbum[],
    trendingSets?: BPMCurated[],
    topDownloads?: BPMAlbum[],
    myPlaylists?: BPMCurated[],
    playlistProviders?: BPMCurated[],
    news?: BPMNews[],
    genres?: BPMGenre[],
    banner?: Banner,
    loading: boolean,
    isLive: boolean
}> {

    context: User
    didScrollToTrack: boolean;

    constructor(props: BrowseProps) {
        super(props);
        this.state = {
            featured: [],
            videos: [],
            recentlyAdded: [],
            trendingSets: [],
            topDownloads: [],
            news: [],
            genres: top5Genres,
            loading: true,
            isLive: false
        }
    }

    componentDidMount() {
        this.props.onLoading(true)
        Promise.all([this.getTopDownloads(), this.getCuratedSets(), this.getNewReleases(),
        this.getNews(), this.getFeatured(), this.getBanner(), this.getMyPlaylists()]).finally(() => {
            this.props.onLoading(false)
            this.setState({ loading: false }, () => {
                if (!this.didScrollToTrack) {
                    this.scrollToHash()
                }
            })
        })
        if (location.search) {
            if (location.search.includes('login')) {
                let promise = Promise.resolve('') as PromiseLike<string | void>
                switch (this.context.verification_status) {
                    case 'declined':
                    case 'not-submitted':
                        promise = Popup.loginMembershipDeniedOrNotSubmitted().then(result => {
                            if (result == 'ok') {
                                window.location.assign(Environment.POOL_URL + '/membership-request');
                                return Promise.reject()
                            }
                        }) as PromiseLike<string | void>
                        break
                    case 'pending':
                        promise = Popup.loginMembershipPending().then(result => {

                        })
                        break
                    case 'verified':
                        if (this.props.membership == SubscriptionInfo.None && !this.props.membershipExpired) {
                            promise = Popup.loginMembershipApproved().then(result => {
                                if (result == 'ok') {
                                    window.location.assign('/subscribe')
                                }
                            })
                        }
                        break
                }
                promise.then(() => {
                    history.pushState({}, document.title, location.pathname + (location.search.replace('login', '')))
                })
            }
        }
    }

    componentDidUpdate() {
        if (!this.didScrollToTrack && !this.state.loading) {
            this.scrollToHash()
        }
    }

    scrollToHash() {
        if (location.hash) {
            this.didScrollToTrack = true
            const element = document.getElementById(location.hash.slice(1))
            element &&
                window.scrollTo({
                    top: element.offsetTop - 80,
                    behavior: 'smooth'
                });
        }
    }


    private getBanner() {
        return bannerAPI.getBanner('browse').then(({ data: banner }) => {
            this.setState({ banner })
        }).catch(err => {
            this.setState({ banner: undefined })
        })
    }

    private getNews() {
        return NewsAPI.getNewsForProvider('6046bbc1-6805-11e9-8527-0ea141e7e82c', undefined, pagingInfo).then(news => {
            this.setState({ news: news.map(apiNewsToBPMNews) })
        }).catch(err => {
            this.setState({ news: undefined })
        })
    }

    private getTopDownloads() {
        return albumAPI.getTrendingAlbumPeriod('monthly', 10, 0, undefined, 'music').then((result) => {
            this.setState({
                topDownloads: result.data.map(apiAlbumToBPMAlbum)
            })
        }).catch((error) => {
            this.setState({
                topDownloads: undefined
            })
        })
    }

    private getFeatured() {
        return Promise.all([
            mediaAPI.getAlbumFeatured(20, 0, 'music').then((result) => {
                this.setState({
                    featured: result.data.map(apiAlbumToBPMAlbum).sort(() => Math.random() - Math.random())
                })
            }).catch(() => {
                this.setState({
                    featured: undefined
                })
            }),
            albumAPI.getFeaturedBpmoriginalAlbums(15, 0, undefined, undefined, 'music').then((result) => {
                this.setState({
                    featured_bpm_orignals: result.data.map(apiAlbumToBPMAlbum).sort(() => Math.random() - Math.random())
                })
            }).catch(() => {
                this.setState({
                    featured_bpm_orignals: undefined
                })
            })
        ])

    }

    private getCuratedSets() {
        return playlistAPI.getPlaylistSets(20, 0, 'music').then((result) => {
            this.setState({
                trendingSets: result.data.map(mapPlaylist)
            })
        }).catch((error) => {
            this.setState({
                trendingSets: undefined
            })
        })
    }

    private getNewReleases() {
        return mediaAPI.searchAlbum(15, 0, undefined, 'music', undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, SortByQueryOptions.DateDesc).then((result) => {
            this.setState({
                recentlyAdded: result.data.map(apiAlbumToBPMAlbum)
            })
        }).catch((error) => {
            this.setState({
                recentlyAdded: undefined
            })
        })
    }

    private async getMyPlaylists() {
        return userPlaylistAPI.getForYouPlaylistSets('music').then((list) => {
            const myPlaylists = list.data.available.map((l) => mapUserPlaylist(l))
            const notCreatedPlaylists = list.data.not_available
            notCreatedPlaylists.forEach((provider) => {
                myPlaylists.push(mapPlaylistProvider(provider, this.context))
            })
            this.setState({ myPlaylists: myPlaylists })
        }).catch(err => {

        })
    }

    private showLiveStream() {
        return this.state.isLive
    }

    public render() {
        if (this.state.loading) {
            return <></>
        }
        return (
            <>
                {this.showLiveStream() && <div className='banner' style={{ marginBottom: "40px" }}>
                    <Live {...this.props} maxHeight={500} useLiveInline />
                </div>}
                {!this.showLiveStream() && this.state.banner && this.state.banner.images.length > 0 && <div className='banner' style={{ marginBottom: "40px" }}>
                    <Carousel showArrows useKeyboardArrows autoPlay stopOnHover infiniteLoop interval={6500} transitionTime={500}
                        showThumbs={false} showStatus={false} showIndicators={false} onClickItem={(index: number) => {
                            const banner = this.state.banner?.images[index]
                            if (banner?.link?.startsWith('http')) {
                                Analytics.trackClick('banner', banner.id)
                                window.open(banner.link, '__blank')
                            } else if (banner?.link) {
                                Analytics.trackClick('banner', banner.id)
                                window.open(`${Environment.NEW_POOL_URL}${banner.link}`, '__blank')
                            }
                        }}>

                        {this.state.banner.images.map((image) => {
                            return <div className='banner-container' key={image.id}
                                style={{
                                    backgroundColor: image.background_color,
                                    backgroundImage: `url("${image.image_url_large}")`,
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: '50% 100%'
                                }}>
                            </div>
                        })}
                    </Carousel>
                </div>}
                <Box>
                    {this.state.featured ?
                        <>
                            <CoverList
                                albums={this.state.featured.slice(0, 20)}
                                headline={'Featured'}
                                size={"large"}
                                viewAll
                                onViewAllClick={() => {
                                    this.props.history.push('/featured')
                                }}
                                onItemClick={(set: BPMAlbum) => {
                                    this.props.history.push('/share/' + set.id)
                                }}
                                style={{ marginBottom: 20 }}
                                context={'browse_featured'}
                                {...this.props}
                            />
                            {this.state.featured.length > 20 && <CoverList
                                albums={this.state.featured.slice(20)}
                                size={"small"}
                                context={'browse_featured_small'}
                                {...this.props}
                            />}
                        </>
                        :
                        <div>Sorry, something went wrong. Please try again.</div>
                    }
                </Box>
                {this.state.myPlaylists && this.state.myPlaylists.length > 0 &&
                    <Box style={{ marginTop: "40px" }} id='forYou'>
                        <CoverList
                            curatedSets={this.state.myPlaylists}
                            loadAlbumsForSet={(set) => userPlaylistAPI.getUserPlaylistSet(set.id as string).then(({ data }) => data.albums?.map(apiAlbumToBPMAlbum) || [])}
                            onItemClick={(set: BPMCurated) => {
                                if (!set.playable) {
                                    return Popup.downloadMore()
                                }
                                this.props.history.push('/playlists/forYou/' + set.id)
                            }}
                            headline={'For You'}
                            size={"large"}
                            context={'my_playlists'}
                            style={{ marginBottom: 20 }}
                            {...this.props}
                        />
                    </Box>
                }
                {this.state.playlistProviders && this.state.playlistProviders.length > 0 &&
                    <Box style={{ marginTop: "40px" }} id='forYou'>
                        <CoverList curatedSets={this.state.playlistProviders}
                            loadAlbumsForSet={() => Promise.reject()}
                            context={'my_playlists'} headline={'For You'} key={'my_playlists-key'}
                            onItemClick={() => {
                                Session.getSubscriptionHandler()!(({
                                    current_supscription: SubscriptionInfo.None,
                                    required_subscription: SubscriptionInfo.Standard
                                } as InvalidSubscriptionError))
                            }} size={"large"} style={{ marginBottom: 20 }} {...this.props} />
                    </Box>
                }
                <Box style={{ marginTop: "40px" }}>
                    {this.state.featured_bpm_orignals ?
                        <>
                            <CoverList
                                albums={this.state.featured_bpm_orignals.slice(0, 20)}
                                headline={'Featured BPM Originals'}
                                size={"large"}
                                viewAll
                                onViewAllClick={() => {
                                    this.props.history.push('/new-releases/audio/bpm-originals')
                                }}
                                onItemClick={(set: BPMAlbum) => {
                                    this.props.history.push('/share/' + set.id)
                                }}
                                style={{ marginBottom: 20 }}
                                context={'browse_featured_bpm'}
                                {...this.props}
                            />
                            {this.state.featured_bpm_orignals.length > 20 && <CoverList
                                albums={this.state.featured_bpm_orignals.slice(20)}
                                size={"small"}
                                context={'browse_featured_small'}
                                {...this.props}
                            />}
                        </>
                        :
                        <div>Sorry, something went wrong. Please try again.</div>
                    }
                </Box>
                <Box style={{ marginTop: "40px" }}>
                    {this.state.trendingSets ?
                        <CoverList
                            curatedSets={this.state.trendingSets}
                            loadAlbumsForSet={(set) => playlistAPI.getPlaylistSet(set.id as number).then(({ data }) => data.albums?.map(apiAlbumToBPMAlbum) || [])}
                            onItemClick={(set: BPMCurated) => {
                                this.props.history.push('/playlists/' + set.slug)
                            }}
                            headline={'Playlists'}
                            size={"large"}
                            viewAll
                            context={'browse_trending'}
                            style={{ marginBottom: 20 }}
                            onViewAllClick={() => {
                                this.props.history.push('/playlists')
                            }}
                            {...this.props}
                        />
                        :
                        <div className="browse-error">Sorry, something went wrong. Please try again.</div>
                    }
                </Box>
                <Box style={{ marginTop: "40px" }}>
                    {this.state.topDownloads ?
                        <div>
                            <div className="coverlist-header">
                                {<span className="headline">{'Trends'}</span>}
                                {<span className="viewall" onClick={() => {
                                    this.props.history.push('/trends')
                                }}>{'See All'}</span>}

                            </div>
                            <ListView
                                {...this.props}
                                noBox
                                artistColumn
                                className='inline-list small-cover-art' contentType={'audio'}
                                style={{ marginBottom: 20 }}
                                albums={this.state.topDownloads} context={'topdownlaods'} />
                        </div>
                        :
                        <div className="browse-error">Sorry, something went wrong. Please try again.</div>
                    }
                </Box>
                <Box style={{ marginTop: "40px" }} className='genre-list'>
                    {this.state.genres ? <HorizontalList itemStyle={{ letterSpacing: '0.1px' }}
                        items={this.state.genres as any} headline={'Genres'} size='large' onViewAllClick={() => {
                            this.props.history.push('/genres')
                        }}
                        renderItem={(item: any) => {
                            return <div className={"coverlist-item " + item.slug} key={item.id} onClick={(e) => {
                                e.preventDefault()
                                this.props.history.push('/new-releases/audio/genre/' + (item.slug as string))
                            }}>
                                <div className="text-container">
                                    <div className='item-text item-title text'>{item.name}</div>
                                </div>
                            </div>
                        }} /> : <div className="browse-error">Sorry, something went wrong. Please try again.</div>}

                </Box>
                <Box style={{ marginTop: "40px" }}>
                    {this.state.recentlyAdded ?
                        <GridList
                            albums={this.state.recentlyAdded}
                            headline={'Recently Added'}
                            context={'browse_recent'}
                            viewAll
                            onItemClick={(album) => {
                                this.props.history.push('/share/' + album.id)
                            }}
                            onViewAllClick={() => {
                                this.props.history.push('/new-releases')
                            }}
                            {...this.props}
                        />
                        :
                        <div className="browse-error">Sorry, something went wrong. Please try again.</div>
                    }
                </Box>
                <Box style={{ marginTop: "40px" }} className='news-list'>
                    {this.state.news && this.state.news.length > 0 && <HorizontalList itemStyle={{ letterSpacing: '0.1px' }} items={this.state.news.map(item => {
                        return {
                            id: item.id!,
                            image: item.image_url!,
                            onClick: () => {
                                window.open(item.link)
                            }, title: item.title, subTitle: NewsListView.convertText(item.rendered)
                        }
                    })} headline={'BPM News'} size='news' />}
                    {!this.state.news && <div className="browse-error">Sorry, something went wrong. Please try again.</div>}
                </Box>
            </>
        )
    }
}
BrowseInner.contextType = UserContextType
export const Browse = withToast(withRouter(BrowseInner))


// WEBPACK FOOTER //
// ./src/pages/Browse.tsx